<div [fxLayout]="'row'">
  <div class="label" [ngClass]="{ 'blue-bg': showBlueBackground }">
    {{ label }}
    <i *ngIf="showCheckedSymbol" class="icon zmdi zmdi-check"></i>
  </div>
  <div class="value">{{ value }}</div>
</div>
